import type { Directive } from "vue";

/**
 * Toggles the `button-active` class on a clicked BUTTON element.
 */
function toggleActiveClassOnButton(evt: Event): void {
  const target = evt.currentTarget as HTMLElement | null;
  if (target && target.nodeName === "BUTTON") {
    target.classList.toggle("button-active");
  }
}

const ButtonActiveToggle: Directive<HTMLElement> = {
  beforeMount(el) {
    el.addEventListener("click", toggleActiveClassOnButton);
  },

  unmounted(el) {
    el.removeEventListener("click", toggleActiveClassOnButton);
  }
};

export default ButtonActiveToggle;
